import { useDelayContext } from './Delay'

interface FadeSlideAnimationProps {
  children: React.ReactNode
}

export function FadeSlideAnimation({ children }: FadeSlideAnimationProps) {
  const { visible } = useDelayContext()

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateRows: visible ? '1fr' : '0fr',
        opacity: visible ? 1 : 0,
        // Stagger the two transitions so the row first expands (0→100%) and
        // only then does the content fade in (0→100%) — instead of fading in
        // while it grows. On exit we reverse the order: fade out, then collapse.
        transition: visible
          ? 'grid-template-rows .15s, opacity .15s .15s'
          : 'grid-template-rows .15s .15s, opacity .15s',
      }}
    >
      <div style={{ overflow: 'hidden' }}>{children}</div>
    </div>
  )
}
